import {h, Fragment} from "preact"
import Product from "./Product"
import { useEffect } from "preact/hooks"
import { useAppStateSelector } from "@nosto/preact"

export default function Products() {
    const {
        products,
        loading
    } = useAppStateSelector(state => ({ products: state.response.products, loading: state.loading }))

    console.log("products are", products)

    return (
        <div class="ns-product-grid" style={loading ? "opacity: 0.3;" : ""}>
            {products.hits.map((hit, index) => {
                return <Product product={hit} key={hit.productId || index} wishlistItems={localStorage.iWishlistmain} />
            })}
        </div>
    )
}
